enum JourneyType {
    OwnWayThere	= 0,
    PassengerToLocation	= 1,
    PassengerFromLocation = 2,
    PassengerRoundTrip = 3,
    DriverToLocation	= 4,
    DriverFromLocation = 5,
    DriverRoundTrip = 6,   
}
export default JourneyType;